import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";

import "./SelectDropdown.styles.css";

export default function SelectDropdown({
  value,
  onChange,
  title,
  name,
  viewName,
  options,
  getOptions,
  required,
  asSearchable,
  placeholder,
  multiple,
  initialValue,
  readOnly = false,
  hideEmptyOption = false,
}) {
  const [optionsFinal, setOptionsFinal] = useState(() => options || []);
  const [selected, setSelected] = useState([]);

  const handleChange = (newSelected) => {
    if (!onChange) return setSelected(Array.isArray(newSelected) ? newSelected : newSelected ? [newSelected] : []);

    const value = Array.isArray(newSelected) ? newSelected.map((selected) => selected.value) : newSelected?.value || initialValue || "";
    const viewValue = Array.isArray(newSelected) ? newSelected.map((selected) => selected.label || selected.name || "") : newSelected?.label || newSelected?.name || "";

    onChange({ target: { name, value } }, viewName && viewName !== name ? { [viewName]: viewValue } : undefined);
  };

  useEffect(() => {
    if (Array.isArray(options)) setOptionsFinal(options.map((o) => ({ ...o, label: o.label || o.name })));
  }, [options]);

  useEffect(() => {
    setSelected(optionsFinal.filter((o) => (Array.isArray(value) ? value.includes(o.value) : o.value === value)));
  }, [optionsFinal, value]);

  useEffect(() => {
    if (!getOptions || Array.isArray(options)) return;

    getOptions().then((response) => setOptionsFinal(response.data));
  }, [getOptions, options]);

  return asSearchable || multiple ? (
    <ReactSelect
      menuPlacement={"bottom"}
      placeholder={placeholder || `Select ${title}`}
      className={"select-input"}
      value={selected}
      options={optionsFinal}
      onChange={handleChange}
      isDisabled={readOnly}
      menuPortalTarget={document.body}
      isClearable={!required && value !== initialValue}
      isMulti={multiple}
      closeMenuOnSelect
    />
  ) : (
    <select value={value} onChange={onChange} name={name} disabled={readOnly} className="form-control">
      {!hideEmptyOption && (
        <option value={""} disabled={required && value && value !== 0 && optionsFinal.length > 0}>
          {placeholder || `Select ${title}`}
        </option>
      )}
      {optionsFinal.map((option) => (
        <option value={option.value} key={option.value}>
          {option.label || option.name}
        </option>
      ))}
    </select>
  );
}
